import { useState } from 'react'
import { router } from '@inertiajs/react'
import { useFlashToast } from '../../../hooks/useFlashToast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faMagnifyingGlass, faXmark,
  faPlus, faTrash, faToggleOn, faToggleOff, faCircleCheck,
  faCircleXmark, faEye, faPen, faUserTie, faUser, faBuilding, faGlobe
} from '@fortawesome/free-solid-svg-icons'
import SuperadminSidebar from '../../../components/superadmin/Sidebar'
import SuperadminTopbar from '../../../components/superadmin/Topbar'

function ConfirmModal({ message, onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 w-full max-w-sm shadow-2xl">
        <p className="text-gray-200 text-sm mb-5">{message}</p>
        <div className="flex gap-3 justify-end">
          <button onClick={onCancel} className="px-4 py-2 text-sm text-gray-400 hover:text-gray-200 rounded-lg hover:bg-gray-700">Batal</button>
          <button onClick={onConfirm} className="px-4 py-2 text-sm font-semibold bg-red-600 hover:bg-red-500 text-white rounded-lg">Ya, lanjutkan</button>
        </div>
      </div>
    </div>
  )
}

function CreateModal({ onClose, tab }) {
  const defaultType = tab === 'admins' || tab === 'internal' ? 'internal' : 'external'
  const [form, setForm] = useState({ username: '', name: '', email: '', password: '', user_type: defaultType, admin: tab === 'admins' ? '1' : '0', skip_confirmation: '1' })
  const [loading, setLoading] = useState(false)

  const handleUserTypeChange = (e) => {
    const newType = e.target.value
    setForm({ ...form, user_type: newType, admin: newType === 'external' ? '0' : form.admin })
  }

  const submit = (e) => {
    e.preventDefault()
    setLoading(true)
    router.post('/superadmin/users', { user: form }, {
      onFinish: () => { setLoading(false); onClose() }
    })
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="bg-gray-800 border border-gray-700 rounded-xl w-full max-w-md shadow-2xl">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-700">
          <h3 className="font-semibold text-white text-sm">Tambah {tab === 'admins' ? 'Admin' : 'Pengguna'} Baru</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-300">
            <FontAwesomeIcon icon={faXmark} className="w-4 h-4" />
          </button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Username *</label>
              <input required value={form.username} onChange={e => setForm({...form, username: e.target.value})}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Nama Lengkap</label>
              <input value={form.name} onChange={e => setForm({...form, name: e.target.value})}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Email *</label>
            <input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Password *</label>
            <input required type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Tipe Pengguna</label>
              <select value={form.user_type} onChange={handleUserTypeChange}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none">
                <option value="external">External</option>
                <option value="internal">Internal</option>
              </select>
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">
                Role
                {form.user_type === 'external' && <span className="ml-1 text-amber-500">(hanya internal)</span>}
              </label>
              <select value={form.admin} onChange={e => setForm({...form, admin: e.target.value})}
                disabled={form.user_type === 'external'}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none disabled:opacity-40 disabled:cursor-not-allowed">
                <option value="0">User</option>
                <option value="1">Admin</option>
              </select>
            </div>
          </div>
          <label className="flex items-center gap-2 text-xs text-gray-400 cursor-pointer">
            <input type="checkbox" checked={form.skip_confirmation === '1'} onChange={e => setForm({...form, skip_confirmation: e.target.checked ? '1' : '0'})}
              className="rounded bg-gray-900 border-gray-700 text-indigo-500" />
            Lewati verifikasi email
          </label>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 py-2 text-sm text-gray-400 border border-gray-700 rounded-lg hover:bg-gray-700">Batal</button>
            <button type="submit" disabled={loading}
              className="flex-1 py-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg disabled:opacity-60">
              {loading ? 'Menyimpan...' : 'Simpan'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

function EditModal({ user, onClose }) {
  const [form, setForm] = useState({ username: user.username, name: user.name || '', email: user.email, password: '', user_type: user.user_type })
  const [loading, setLoading] = useState(false)

  const submit = (e) => {
    e.preventDefault()
    setLoading(true)
    router.patch(`/superadmin/users/${user.id}`, { user: form }, {
      onFinish: () => { setLoading(false); onClose() }
    })
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="bg-gray-800 border border-gray-700 rounded-xl w-full max-w-md shadow-2xl">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-700">
          <h3 className="font-semibold text-white text-sm">Edit: {user.username}</h3>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-300">
            <FontAwesomeIcon icon={faXmark} className="w-4 h-4" />
          </button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Username *</label>
              <input required value={form.username} onChange={e => setForm({...form, username: e.target.value})}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Nama Lengkap</label>
              <input value={form.name} onChange={e => setForm({...form, name: e.target.value})}
                className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
            </div>
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Email *</label>
            <input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Password baru <span className="text-gray-600">(kosongkan jika tidak diubah)</span></label>
            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none" />
          </div>
          <div>
            <label className="text-xs text-gray-400 mb-1 block">Tipe Pengguna</label>
            <select value={form.user_type} onChange={e => setForm({...form, user_type: e.target.value})}
              className="w-full bg-gray-900 border border-gray-700 text-gray-200 text-sm rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 outline-none">
              <option value="external">External</option>
              <option value="internal">Internal</option>
            </select>
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 py-2 text-sm text-gray-400 border border-gray-700 rounded-lg hover:bg-gray-700">Batal</button>
            <button type="submit" disabled={loading}
              className="flex-1 py-2 text-sm font-semibold bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg disabled:opacity-60">
              {loading ? 'Menyimpan...' : 'Simpan'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default function SuperadminUsersIndex({ current_user, users, tab, query, stats }) {
  useFlashToast()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [searchVal, setSearchVal] = useState(query)
  const [showCreate, setShowCreate] = useState(false)
  const [editUser, setEditUser] = useState(null)
  const [confirm, setConfirm] = useState(null) // { message, onConfirm }

  const navigate = (newTab, q) => {
    router.get('/superadmin/users', { tab: newTab, q: q ?? searchVal }, { preserveState: true })
  }

  const handleSearch = (e) => {
    e.preventDefault()
    navigate(tab, searchVal)
  }

  const toggleAdmin = (user) => {
    const action = user.admin ? 'mencabut role admin' : 'menjadikan admin'
    setConfirm({
      message: `Yakin ingin ${action} untuk "${user.username}"?`,
      onConfirm: () => {
        router.patch(`/superadmin/users/${user.id}/toggle_admin`)
        setConfirm(null)
      }
    })
  }

  const toggleConfirmation = (user) => {
    const action = user.confirmed ? 'mencabut konfirmasi' : 'mengkonfirmasi'
    setConfirm({
      message: `Yakin ingin ${action} akun "${user.username}"?`,
      onConfirm: () => {
        router.patch(`/superadmin/users/${user.id}/toggle_confirmation`)
        setConfirm(null)
      }
    })
  }

  const deleteUser = (user) => {
    setConfirm({
      message: `Hapus pengguna "${user.username}"? Tindakan ini tidak dapat dibatalkan.`,
      onConfirm: () => {
        router.delete(`/superadmin/users/${user.id}`)
        setConfirm(null)
      }
    })
  }

  return (
    <div className="flex h-screen bg-gray-950 font-sans overflow-hidden text-gray-100">
      <SuperadminSidebar current_user={current_user} open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <SuperadminTopbar current_user={current_user} onMenuToggle={() => setSidebarOpen(true)}>
          <form onSubmit={handleSearch} className="flex-1 max-w-md">
            <div className="relative">
              <FontAwesomeIcon icon={faMagnifyingGlass} className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
              <input value={searchVal} onChange={e => setSearchVal(e.target.value)}
                placeholder="Cari username, nama, email..."
                className="w-full pl-9 pr-4 py-2 text-sm bg-gray-800 border border-gray-700 text-gray-300 placeholder-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none" />
            </div>
          </form>
        </SuperadminTopbar>

        <main className="flex-1 overflow-y-auto p-4 lg:p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div>
              <h1 className="text-xl font-bold text-white">Manajemen Pengguna dan Admin</h1>
              <p className="text-sm text-gray-500 mt-0.5">Kelola admin dan pengguna sistem WBS</p>
            </div>
            <button onClick={() => setShowCreate(true)}
              className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold rounded-lg transition-colors">
              <FontAwesomeIcon icon={faPlus} className="w-3.5 h-3.5" />
              Tambah {tab === 'admins' ? 'Admin' : tab === 'internal' ? 'Internal' : tab === 'external' ? 'Eksternal' : 'Pengguna'}
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 mb-6">
            {[
              { label: 'Total Pengguna', value: stats.total_users,    icon: faUser,        color: 'text-sky-400',     bg: 'bg-sky-900/40' },
              { label: 'Total Admin',    value: stats.total_admins,   icon: faUserTie,     color: 'text-indigo-400',  bg: 'bg-indigo-900/40' },
              { label: 'Internal',       value: stats.total_internal, icon: faBuilding,    color: 'text-violet-400',  bg: 'bg-violet-900/40' },
              { label: 'Eksternal',      value: stats.total_external, icon: faGlobe,       color: 'text-cyan-400',    bg: 'bg-cyan-900/40' },
              { label: 'Terkonfirmasi',  value: stats.confirmed,      icon: faCircleCheck, color: 'text-emerald-400', bg: 'bg-emerald-900/40' },
              { label: 'Belum Konfirm',  value: stats.unconfirmed,    icon: faCircleXmark, color: 'text-amber-400',   bg: 'bg-amber-900/40' },
            ].map(s => (
              <div key={s.label} className="bg-gray-900 rounded-xl border border-gray-800 p-4 flex items-center gap-3">
                <div className={`w-10 h-10 ${s.bg} rounded-xl flex items-center justify-center flex-shrink-0`}>
                  <FontAwesomeIcon icon={s.icon} className={`w-4 h-4 ${s.color}`} />
                </div>
                <div>
                  <div className="text-xl font-bold text-white">{s.value}</div>
                  <div className="text-[11px] text-gray-500">{s.label}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Tabs */}
          <div className="flex flex-wrap gap-1 mb-4 bg-gray-900 border border-gray-800 rounded-xl p-1 w-fit">
            {[
              { key: 'users',    label: 'Semua Pengguna', icon: faUser },
              { key: 'internal', label: 'Internal',       icon: faBuilding },
              { key: 'external', label: 'Eksternal',      icon: faGlobe },
              { key: 'admins',   label: 'Admin',          icon: faUserTie },
            ].map(t => (
              <button key={t.key} onClick={() => navigate(t.key)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  tab === t.key
                    ? t.key === 'internal' ? 'bg-violet-600 text-white'
                    : t.key === 'external' ? 'bg-cyan-700 text-white'
                    : 'bg-indigo-600 text-white'
                    : 'text-gray-400 hover:text-gray-200'
                }`}>
                <FontAwesomeIcon icon={t.icon} className="w-3.5 h-3.5" />
                {t.label}
              </button>
            ))}
          </div>

          {/* Table */}
          <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-800/60 text-[11px] font-semibold text-gray-500 uppercase tracking-wider">
                    <th className="text-left px-5 py-3">Pengguna</th>
                    <th className="text-left px-5 py-3">Email</th>
                    {tab !== 'internal' && tab !== 'external' && <th className="text-left px-5 py-3">Tipe</th>}
                    <th className="text-left px-5 py-3">Status</th>
                    <th className="text-left px-5 py-3">Terakhir Login</th>
                    <th className="text-left px-5 py-3">Bergabung</th>
                    <th className="text-right px-5 py-3">Aksi</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-800">
                  {users.length === 0 && (
                    <tr><td colSpan={tab === 'internal' || tab === 'external' ? 6 : 7} className="px-5 py-8 text-center text-gray-600 text-sm">Tidak ada data.</td></tr>
                  )}
                  {users.map(user => (
                    <tr key={user.id} className="hover:bg-gray-800/40 transition-colors">
                      <td className="px-5 py-3.5">
                        <div className="flex items-center gap-3">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-bold ${user.admin ? 'bg-indigo-900/60 text-indigo-400 ring-1 ring-indigo-700' : 'bg-gray-800 text-gray-400'}`}>
                            {(user.name || user.username).slice(0, 2).toUpperCase()}
                          </div>
                          <div>
                            <div className="text-gray-200 font-medium text-sm">{user.name || user.username}</div>
                            <div className="text-[11px] text-gray-500">@{user.username}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-5 py-3.5 text-gray-400 text-xs">{user.email}</td>
                      {tab !== 'internal' && tab !== 'external' && (
                        <td className="px-5 py-3.5">
                          <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ring-1 ${user.user_type === 'internal' ? 'bg-violet-900/40 text-violet-400 ring-violet-700/50' : 'bg-cyan-900/40 text-cyan-400 ring-cyan-700/50'}`}>
                            <FontAwesomeIcon icon={user.user_type === 'internal' ? faBuilding : faGlobe} className="w-2.5 h-2.5" />
                            {user.user_type === 'internal' ? 'Internal' : 'Eksternal'}
                          </span>
                        </td>
                      )}
                      <td className="px-5 py-3.5">
                        <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium ring-1 ${user.confirmed ? 'bg-emerald-900/40 text-emerald-400 ring-emerald-700/50' : 'bg-amber-900/40 text-amber-400 ring-amber-700/50'}`}>
                          <FontAwesomeIcon icon={user.confirmed ? faCircleCheck : faCircleXmark} className="w-3 h-3" />
                          {user.confirmed ? 'Terverifikasi' : 'Belum Verifikasi'}
                        </span>
                      </td>
                      <td className="px-5 py-3.5 text-gray-500 text-xs">{user.last_sign_in_at || '—'}</td>
                      <td className="px-5 py-3.5 text-gray-500 text-xs">{user.created_at}</td>
                      <td className="px-5 py-3.5">
                        <div className="flex items-center gap-1 justify-end">
                          <a href={`/superadmin/users/${user.id}`}
                            title="Detail" className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-500 hover:text-sky-400 hover:bg-gray-800 transition-colors">
                            <FontAwesomeIcon icon={faEye} className="w-3.5 h-3.5" />
                          </a>
                          <button onClick={() => setEditUser(user)}
                            title="Edit" className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-500 hover:text-indigo-400 hover:bg-gray-800 transition-colors">
                            <FontAwesomeIcon icon={faPen} className="w-3.5 h-3.5" />
                          </button>
                          {!user.superadmin && user.user_type === 'internal' && (
                            <button onClick={() => toggleAdmin(user)} title={user.admin ? 'Cabut Admin' : 'Jadikan Admin'}
                              className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-500 hover:text-amber-400 hover:bg-gray-800 transition-colors">
                              <FontAwesomeIcon icon={user.admin ? faToggleOn : faToggleOff} className="w-4 h-4" />
                            </button>
                          )}
                          {!user.superadmin && user.user_type === 'external' && !user.admin && (
                            <div title="Hanya pengguna internal yang dapat dijadikan admin"
                              className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-700 cursor-not-allowed">
                              <FontAwesomeIcon icon={faToggleOff} className="w-4 h-4" />
                            </div>
                          )}
                          <button onClick={() => toggleConfirmation(user)} title={user.confirmed ? 'Cabut Konfirmasi' : 'Konfirmasi Akun'}
                            className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-500 hover:text-emerald-400 hover:bg-gray-800 transition-colors">
                            <FontAwesomeIcon icon={user.confirmed ? faCircleXmark : faCircleCheck} className="w-3.5 h-3.5" />
                          </button>
                          {!user.superadmin && (
                            <button onClick={() => deleteUser(user)} title="Hapus"
                              className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-500 hover:text-red-400 hover:bg-gray-800 transition-colors">
                              <FontAwesomeIcon icon={faTrash} className="w-3.5 h-3.5" />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>

      {showCreate && <CreateModal tab={tab} onClose={() => setShowCreate(false)} />}
      {editUser && <EditModal user={editUser} onClose={() => setEditUser(null)} />}
      {confirm && <ConfirmModal message={confirm.message} onConfirm={confirm.onConfirm} onCancel={() => setConfirm(null)} />}
    </div>
  )
}
